export default "__VITE_ASSET__B7xX8SrY__"